<app-dashboard-layout>
  <div class="container">
    <div class="lang-container">
      <app-switch-lang></app-switch-lang>
    </div>
    <a [routerLink]="'/'">
      <img src="../../../../assets/img/fruzty-logo-slogan.png" width="250" height="auto"/>
    </a>
    <div class="card-login">
      <div class="card-container">
        <div class="header-card">
          <h2 class="title-form">{{'ResetPasswordPage.CardHeader' | translate}}</h2>
          <h3 class="subtitle-form">{{'ResetPasswordPage.CardSubheader' | translate}}</h3>
        </div>
        <form [formGroup]="formGroup">
          <div class="p-fluid formgrid grid">
            <div class="field col-12" style="margin-bottom: 10px;">
              <label class="label-form" for="newPassword">{{'ResetPasswordPage.NewPasswordFieldLabel' | translate}} *</label>
              <p-password  class="input-style" [toggleMask]="true" id="newPassword" formControlName="newPassword" [minlength]="8">
                <ng-template pTemplate="header">
                  <h6>{{'ResetPasswordPage.SubtitlePassword' | translate}}</h6>
                </ng-template>
                <ng-template pTemplate="footer">
                  <p-divider></p-divider>
                  <p class="mt-2">{{'ResetPasswordPage.PasswordSubtitle' | translate}}</p>
                  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                    <li>{{'ResetPasswordPage.PasswordSuggestion1' | translate}}</li>
                    <li>{{'ResetPasswordPage.PasswordSuggestion2' | translate}}</li>
                    <li>{{'ResetPasswordPage.PasswordSuggestion3' | translate}}</li>
                    <!-- <li>Al menos un caracter especial</li> -->
                    <li>{{'ResetPasswordPage.PasswordSuggestion4' | translate}}</li>
                  </ul>
                </ng-template>
              </p-password>
              <small *ngIf="submit && formGroup.controls['newPassword'].invalid" class="p-error">{{getErrorMessage('newPassword')}}</small>
            </div>
            <div class="field col-12" style="margin-bottom: 20px;">
              <label class="label-form" for="confirmPassword">{{'ResetPasswordPage.ConfirmPasswordFieldLabel' | translate}} *</label>
              <p-password  class="input-style" [toggleMask]="true" id="confirmPassword" formControlName="confirmPassword" [minlength]="8" [feedback]="false"></p-password>
              <small *ngIf="submit && formGroup.controls['confirmPassword'].invalid" class="p-error">{{getErrorMessage('confirmPassword')}}</small>
              <small *ngIf="submit && passwordMatchError" class="p-error">{{'ResetPasswordPage.PasswordErrorMessageText' | translate}}</small>
            </div>
            <div class="field col-12">
              <p-button label="{{'ResetPasswordPage.SendButton' | translate}}" [loading]="loading" (click)="onSubmit()"/>
            </div>
            <div class=" col-12">
              <p-message *ngIf="success" severity="success" text="{{'ResetPasswordPage.SuccessMessage' | translate}}"></p-message>
            </div>
            <div class="field col-12 flex justify-content-between ">
              <a class="link-second" [routerLink]="'/login'">{{'ResetPasswordPage.BackLink' | translate}}</a>
              <a *ngIf="success" [routerLink]="'/login'">{{'ResetPasswordPage.LoginLink' | translate}}</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</app-dashboard-layout>
